<template>
  <section>
    <Header :state="state"></Header>
    <div class="content_wrap">
      <div class="content_box">
        <div class="container_box">
          <div class="box_top">
            <img src="/static/images/trans.png" alt="">
            <p class="box_p1">对公支付<span>订单号：{{orderId}} </span></p>
            <p class="box_desc">请于5个工作日内完成转账，转账成功后我们会在2个工作日内为您处理。如您有任何疑问，请拨打服务热线：199 3225 0218</p>
          </div>
          <div class="box_bottom">
            <p class="bottom_title">对公账号</p>
            <p class="bottom_item">账户名称<span>北京瑞森永安科技有限公司</span></p>
            <p class="bottom_item">开户银行<span>民生银行北京回龙观支行</span></p>
            <p class="bottom_item">银行账号<span>160 794 869</span></p>
            <p class="bottom_item">汇款金额<span>¥<span>{{orderTotal}}元/年</span></span></p>
            <p class="bottom_item">汇款备注<span>请务必备注订单号与手机号，中间用分号间隔</span></p>
            <p class="bottom_tip">温馨提示：为了方便您后期付款，请将本页面内容截图或拍照保存，以便查看付款账号信息及订单号</p>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </section>
</template>
<script>
import Header from '../components/common/header'
import Footer from '../components/common/footer'
export default {
  name: 'home',
  components: { Header,Footer },
  data () {
    return {
      state:1,
      orderId:'',
      orderTotal:0,
    }
  },
  created(){
    this.orderId = JSON.parse(this.$Base64.decode(this.$route.query.orderId));
    this.orderTotal = JSON.parse(this.$Base64.decode(this.$route.query.orderTotal));
    console.log(this.orderTotal)
  },
  methods:{

  }
}
</script>
<style lang="less" scoped>
*{
  font-family:PingFangSC-Regular,PingFang SC;
}
.content_wrap{
  width: 100%;
  padding: 40px 0;
  background: #F5F5F5;
  .content_box{
    width: 71.5%;
    height: 720px;
    margin: 0 auto;
    background: #ffffff;
    .container_box{
      width: 92.6%;
      height: 100%;
      margin: 0 auto;
      .box_top{
        height: 230px;
        border-bottom: 1px solid #E0E0E0;
        position: relative;
        img{
          height: 123px;
          display: block;
          position: absolute;
          top: 58px;
          left: 0;
        }
        .box_p1{
          color: #333333;
          font-size:30px;
          font-weight:500;
          line-height:42px;
          position: absolute;
          top: 87px;
          left: 220px;
          padding: 0;
          margin: 0;
        }
        .box_desc{
          font-size:17px;
          line-height:24px;
          color: #999999;
          text-align: left;
          position: absolute;
          top: 145px;
          left: 220px;
          padding: 0;
          margin: 0;
        }
      }
      .box_bottom{
        color: #333333;
        text-align: center;
        font-weight: 400;
        .bottom_title{
          margin: 49px 0 40px;
          font-weight: 500;
          line-height:42px;
          font-size: 30px;
        }
        .bottom_item{
          line-height: 30px;
          font-size: 22px;
          width: 600px;
          margin: 0 auto 20px;
          text-align: left;
          span{
            margin-left: 30px;
            span{
              color: red;
              margin-left: 5px;
              font-weight: 600;
            }
          }
        }
        .bottom_tip{
          color: #999999;
          font-size:17px;
          line-height:24px;
          margin-top: 50px;
        }
      }
    }
  }
}
@media (min-width: 1024px){
  .content_wrap{
    width: 100%;
    padding: 0.4rem 0;
    background: #F5F5F5;
    .content_box{
      width: 71.5%;
      height: 7.2rem;
      margin: 0 auto;
      background: #ffffff;
      .container_box{
        width: 92.6%;
        height: 100%;
        margin: 0 auto;
        .box_top{
          height: 2.3rem;
          border-bottom: 1px solid #E0E0E0;
          position: relative;
          img{
            height: 1.23rem;
            display: block;
            position: absolute;
            top: 0.58rem;
            left: 0;
          }
          .box_p1{
            color: #333333;
            font-size:0.3rem;
            font-weight:500;
            line-height:0.42rem;
            position: absolute;
            top: 0.87rem;
            left: 2.2rem;
            padding: 0;
            margin: 0;
          }
          .box_desc{
            font-size:0.17rem;
            line-height:0.24rem;
            color: #999999;
            text-align: left;
            position: absolute;
            top: 1.45rem;
            left: 2.2rem;
            padding: 0;
            margin: 0;
          }
        }
        .box_bottom{
          color: #333333;
          text-align: center;
          font-weight: 400;
          .bottom_title{
            margin: 0.5rem 0 0.4rem;
            font-weight: 500;
            line-height:0.42rem;
            font-size: 0.3rem;
          }
          .bottom_item{
            line-height: 0.3rem;
            font-size: 0.22rem;
            width: 6rem;
            margin: 0 auto 0.2rem;
            text-align: left;
            span{
              margin-left: 0.3rem;
              span{
                color: red;
                font-weight: 600;
                margin-left: 0.05rem;
              }
            }
          }
          .bottom_tip{
            color: #999999;
            font-size:0.17rem;
            line-height:0.24rem;
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
@media (min-width: 1680px) {
  .content_wrap{
    width: 100%;
    padding: 40px 0;
    background: #F5F5F5;
    .content_box{
      width: 71.5%;
      height: 720px;
      margin: 0 auto;
      background: #ffffff;
      .container_box{
        width: 92.6%;
        height: 100%;
        margin: 0 auto;
        .box_top{
          height: 230px;
          border-bottom: 1px solid #E0E0E0;
          position: relative;
          img{
            height: 123px;
            display: block;
            position: absolute;
            top: 58px;
            left: 0;
          }
          .box_p1{
            color: #333333;
            font-size:30px;
            font-weight:500;
            line-height:42px;
            position: absolute;
            top: 87px;
            left: 220px;
            padding: 0;
            margin: 0;
          }
          .box_desc{
            font-size:17px;
            line-height:24px;
            color: #999999;
            text-align: left;
            position: absolute;
            top: 145px;
            left: 220px;
            padding: 0;
            margin: 0;
          }
        }
        .box_bottom{
          color: #333333;
          text-align: center;
          font-weight: 400;
          .bottom_title{
            margin: 49px 0 40px;
            font-weight: 500;
            line-height:42px;
            font-size: 30px;
          }
          .bottom_item{
            line-height: 30px;
            font-size: 22px;
            width: 600px;
            margin: 0 auto 20px;
            text-align: left;
            span{
              margin-left: 30px;
              span{
                color: red;
                margin-left: 5px;
                font-weight: 600;
              }
            }
          }
          .bottom_tip{
            color: #999999;
            font-size:17px;
            line-height:24px;
            margin-top: 50px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/transferPage.vue